var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-item"},[_vm._m(0),_c('div',{ref:"chartContainer",staticClass:"chart-container"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_name",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_vm._v("出单产品增长情况")])])
}]

export { render, staticRenderFns }